// QL-505 — a member session's localStorage keys are deliberately named
// differently from the group's `publicSessionToken`/`publicSessionToken_for`
// so the two can never be confused, overwritten, or read across routes.
// Shared by `/p/session/page.tsx` (the eID-callback member flow, `?session=`
// in the URL) and `/p/m/page.tsx` (the one-time-code member flow, the token
// straight off `verify-code`'s response) — both must write the identical
// pair of keys. Kept in its own tiny module rather than re-exported from
// `session/page.tsx` so `/p/m/page.tsx` never pulls in that page's much
// heavier component tree just for two string constants.
export const MEMBER_SESSION_TOKEN_KEY = "memberSessionToken";
export const MEMBER_SESSION_TOKEN_FOR_KEY = "memberSessionToken_for";
